import { Component, OnInit } from '@angular/core';
import { AbstractModalContentComponent } from '@ibe.components/common/modal/abstract-modal-content.component';
import { ModalService } from '@ibe/services/ui';
import { Store } from '@ngrx/store';
import * as fromStore from '@ibe/store/index';
import { FormGroup, FormControl, Validators, FormBuilder, FormArray } from '@angular/forms';
import { Observable, Subscription } from 'rxjs';
import { takeWhile } from 'rxjs/operators';
import { TRIP_TYPE_ONE_WAY, TRIP_TYPE_ROUND_TRIP, SESSION_VAR_KEY_LANGUAGE, DEFAULT_LANGUAGE, EQUIPMENT_CODE_BUS, TRIP_TYPE_ONE_WAY_CODE, TRIP_TYPE_MULTICITY_CODE, SESSION_VAR_KEY_MARKET } from '@ibe.config';
import { BookingStep } from '@ibe/models/ui';
import * as _ from 'lodash';
import { INDRAIbeAdminService } from '@ibe.services/ibeadmin.indra.service';
import { BookedTrip } from '@ibe/models';
import { INDRABookingSearchService } from '@ibe.services/booking-search.indra.service';

@Component({
	selector: 'app-bus-trip-modal',
	templateUrl: './bus-trip-modal.indra.component.html',
	styleUrls: ['./bus-trip-modal.component.scss']
})
export class INDRABusTripModalComponent extends AbstractModalContentComponent implements OnInit {

	optionsHopOff = [
		/* { value: 'PONTEVEDRA', label: 'Pontevedra (Estação de Autocarros em frente à cafetaria)' },
		{ value: 'PORRINO', label: 'Porrino (Eroski Center - Sanguineda)' },
		{ value: 'VIGO', label: 'Vigo (Estação Autocarros Cais 12/13)' } */
	];

	optionsHopOn = [
		/* { value: 'VIGO', label: 'Vigo (Estação Autocarros Cais 12/13)' },
		{ value: 'PORRINO', label: 'Porrino (Eroski Center - Sanguineda)' },
		{ value: 'PONTEVEDRA', label: 'Pontevedra (Estação de Autocarros em frente à cafetaria)' } */
	];

	form: FormGroup;

	private timeToThink$: Observable<boolean> = this.store.select(fromStore.getSelectedBookedTripTimeToThink);
	timeToThink: boolean = false;

	triedToSubmit: boolean = false;
	isAlive: boolean = true;

	booking_trip$: Observable<BookedTrip> = this.store.select(fromStore.getSelectedBookedTrip);
	booking_trip: BookedTrip;
	bookingSteps$: Observable<BookingStep[]> = this.store.select(fromStore.getSelectedBookingSteps);
	bookingSteps: BookingStep[];
	oneWay = TRIP_TYPE_ONE_WAY;

	stops: any;

	allSubscription: Subscription[];
	busStopSubscription: Subscription;

	locations: any;
	busStopLocation: any;

	language: any;
	market: any;

	allSingleStop: boolean = false;
	hopOff: any;
	hopOn: any;
	singleBusStopDetails = [];

	constructor(
		private store: Store<fromStore.State>,
		protected modalService: ModalService,
		private fb: FormBuilder,
		protected ibeAdminService: INDRAIbeAdminService,
		private indraBookingService: INDRABookingSearchService,
	) {
		super(modalService);
		this.TYPE = 'dialog';
		this.timeToThink$
			.pipe(takeWhile(() => this.isAlive))
			.subscribe(value => {
				this.timeToThink = value;
			});

		this.bookingSteps$
			.pipe(takeWhile(() => this.isAlive))
			.subscribe(value => {
				if (value) {
					this.bookingSteps = value;
				}
		});

		this.booking_trip$
			.pipe(takeWhile(() => this.isAlive))
			.subscribe(value => {
				this.booking_trip = value;
		});
	}

	ngOnInit() {
		if (this.data && this.data.length && this.data[0].stops) {
			this.stops = this.data[0].stops;
		}

		if (this.data && this.data.length && this.data[0].locations) {
			this.locations = this.data[0].locations;
		}

		if (this.data && this.data.length && this.data[0].busStopLocation) {
			this.busStopLocation = this.data[0].busStopLocation;
		}
		this.language = sessionStorage.getItem(SESSION_VAR_KEY_LANGUAGE);
		this.market = sessionStorage.getItem(SESSION_VAR_KEY_MARKET);

		this.stops = this.stops.sort((currentStop, nextStop) => currentStop.index - nextStop.index);

		for (const i in this.stops) {
			const busDetails = this.stops[i].busStops;
			const hopOffDetails = [];
			let isMultipleStops = false;
			for (const x in busDetails) {
				/* Temporary Logic for labels. Remove replace when ibeAdminKey is in the correct format */
				const label = 'busStops.label.' + busDetails[x].ibeAdminKey.replace('KEY_', '').replace('_', '');
				const stop = {
					value: busDetails[x].value,
					label: this.INDRA_getTranslation(label),
					hop: busDetails[x].hop
				}
				
				hopOffDetails.push(stop);
				
				if (busDetails[x].hop && busDetails[x].hop.toLowerCase() === 'all') {
					isMultipleStops = true;
				} 
			}

			//if (hopOffDetails.length == 1) {
			if (!isMultipleStops) {
				this.singleBusStopDetails.push(hopOffDetails);
			}

			this.optionsHopOff.push(hopOffDetails);
		}

		if (this.singleBusStopDetails.length == this.optionsHopOff.length) {
			this.allSingleStop = true;
		}

		this.form = this.fb.group({
			stops: this.fb.array([]),
		});

		this.stops.forEach((item, idx) => {
			(this.form.get('stops') as FormArray).push(this.createStops(idx));
		});
	}

	createStops(hopOff: any = ''): FormGroup {
		return this.fb.group({
			hopOff: new FormControl(null, Validators.required),
		});
	}

	closeModal() {
		this.modalService.close();
		this.isAlive = false;
	}

	cancel() {
		this.closeModal();
	}

	confirm() {
		if (this.allSingleStop) {
			const busStops = [];
			for (const i in this.singleBusStopDetails) {
				busStops.push(Object.assign({}, {
					hopOff: this.singleBusStopDetails[i].find(stop => stop.hop && stop.hop.toLowerCase() === 'off').value
				}));
			}

			const returnValue = Object.assign({}, {stops: busStops});
			this.data[0].handleClose(returnValue);
			this.modalService.close();

		} else {
			this.triedToSubmit = true;
			if (this.form.valid) {
				this.data[0].handleClose(this.form.value);
				this.modalService.close();
			}
		}
	}

	INDRA_getCity(index) {
		return `${this.locations[this.stops[index].params.origin].city} - ${this.locations[this.stops[index].params.destination].city}`;
	}

	INDRA_getTranslation(key: string): string {
		return this.ibeAdminService.getTranslationValue(key);
	}

	INDRA_getPlaceholder(index) {
		if (this.booking_trip.booking_type == TRIP_TYPE_ONE_WAY_CODE) {
			return this.INDRA_getTranslation('modals.busTrip.text.selectHopOff');
		} else if ((index + 1) != this.stops.length) {
			return this.INDRA_getTranslation('modals.busTrip.text.selectHopOff');
		}
		return this.INDRA_getTranslation('modals.busTrip.text.selectHopOn');
	}

	INDRA_getBusScheduleURL() {
		return `https://www.flytap.com/${this.language}-${this.market}/other-bookings/transport-galicia-porto`;
	}

	INDRA_isLastStop(index) {
		return (index + 1) == this.singleBusStopDetails.length;
	}
	
	INDRA_displayHopLabel(stops, hopType) {
		if (stops && stops.length) {
			const stop = stops.find(stop => stop.hop && stop.hop.toLowerCase() === hopType);
			return stop ? stop.label : '';
		}
		return '';
	}
}
